import {Injectable} from '@angular/core';
import {
	BackendService,
	ICreateStampRequest,
	ICreateStampResponse,
	IDeleteStampRequest,
	IDeleteUserRequest,
	IDeleteUserResponse,
	IGetPortraitRequest_,
	IGetPortraitResponse_,
	IGetUserResponse_,
	IGetUserStampsRequest,
	IGetUserStampsResponse,
	IUpdatePortraitRequest,
	IUpdatePortraitResponse,
	IUpdateUserRequest_,
	IUpdateUserResponse_,
} from '@core/api/data-access';
import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ActiveUserService extends BackendService {
	constructor() {
		super('users');
	}

	/** -------------------------- USER -------------------------- */

	public getUser(id: string): Observable<IGetUserResponse_> {
		return this.apiService.get(this.getUrl('user'), {search: id});
	}

	public updateUser(request: IUpdateUserRequest_): Observable<IUpdateUserResponse_> {
		return this.apiService.patch(this.getUrl('user'), request);
	}

	/** -------------------------- PORTRAIT -------------------------- */
	public getPortrait(userid: IGetPortraitRequest_['userid']): Observable<IGetPortraitResponse_> {
		return this.apiService.get(this.getUrl('portrait'), {userid});
	}

	public updatePortrait(request: IUpdatePortraitRequest): Observable<IUpdatePortraitResponse> {
		return this.apiService.post(this.getUrl('portrait'), request);
	}

	public deletePortrait(userid: IDeleteUserRequest['userid']): Observable<IDeleteUserResponse> {
		return this.apiService.delete(this.getUrl('portrait'), {userid});
	}

	/** -------------------------- STAMPS -------------------------- */
	public getStamps(userid: IGetUserStampsRequest['userid']): Observable<IGetUserStampsResponse> {
		return this.apiService.get(this.getUrl('stamps'), {userid});
	}

	public createStamp(req: ICreateStampRequest): Observable<ICreateStampResponse> {
		const request = {
			userId: req.userId,
			name: req.name,
			image: req.image,
			imageType: req.imageType,
		};
		return this.apiService.post(this.getUrl('stamps'), request);
	}

	public deleteStamp(userid: IDeleteStampRequest['userid'], name: IDeleteStampRequest['name']): Observable<IDeleteUserResponse> {
		return this.apiService.delete(this.getUrl('stamps'), {userid, name});
	}
}
